import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAdminDisputes } from "../../../redux/actions/profile";

const BG = "#2c2d3f";

const STATUS_COLOR = {
  open: "#e63946", resolved: "#2ec4b6",
  awaiting_merchant_feedback: "#f4a261", awaiting_bank_feedback: "#f4a261",
  pending: "#f4a261", won: "#2ec4b6", lost: "#e63946"
};

export default function Disputes() {
  const dispatch = useDispatch();
  const disputes = useSelector((s) => s.profile.adminDisputes);
  const meta = useSelector((s) => s.profile.adminDisputesMeta);

  const [page, setPage] = useState(1);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [status, setStatus] = useState("");

  const load = (p = page) => {
    const params = { page: p, perPage: 50 };
    if (from) params.from = from;
    if (to) params.to = to;
    if (status) params.status = status;
    dispatch(getAdminDisputes(params));
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(1); }, [dispatch]);

  const fmtMoney = (k) => k != null ? `₦${(k / 100).toLocaleString("en-NG", { minimumFractionDigits: 2 })}` : "—";
  const fmtDate = (d) => d ? new Date(d).toLocaleDateString("en-NG", { day: "2-digit", month: "short", year: "numeric" }) : "—";

  const openCount = disputes.filter((d) => d.status === "open").length;

  return (
    <div style={S.root}>
      <div style={S.pageHeader}>
        <div>
          <h2 style={S.heading}>Disputes</h2>
          <p style={S.headingSub}>{meta?.total || disputes.length} dispute records</p>
        </div>
        {openCount > 0 && (
          <div style={S.alertPill}>
            <i className="bi bi-exclamation-triangle-fill" style={{ marginRight: 6 }} />
            {openCount} open dispute{openCount !== 1 ? "s" : ""} require attention
          </div>
        )}
      </div>

      <div style={S.filterBar}>
        <div style={S.filterGroup}>
          <label style={S.filterLabel}>From</label>
          <input style={S.input} type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
        </div>
        <div style={S.filterGroup}>
          <label style={S.filterLabel}>To</label>
          <input style={S.input} type="date" value={to} onChange={(e) => setTo(e.target.value)} />
        </div>
        <div style={S.filterGroup}>
          <label style={S.filterLabel}>Status</label>
          <select style={S.select} value={status} onChange={(e) => setStatus(e.target.value)}>
            <option value="">All</option>
            <option value="open">Open</option>
            <option value="resolved">Resolved</option>
            <option value="awaiting_merchant_feedback">Awaiting Merchant</option>
            <option value="awaiting_bank_feedback">Awaiting Bank</option>
            <option value="won">Won</option>
            <option value="lost">Lost</option>
          </select>
        </div>
        <div style={{ display: "flex", gap: 8, alignSelf: "flex-end" }}>
          <button style={S.btn} onClick={() => { setPage(1); load(1); }}>Apply Filter</button>
          <button style={S.btnSecondary} onClick={() => { setFrom(""); setTo(""); setStatus(""); setPage(1); dispatch(getAdminDisputes({ page: 1, perPage: 50 })); }}>Reset</button>
        </div>
      </div>

      <div style={S.tableWrap}>
        <table style={S.table}>
          <thead>
            <tr>
              {["ID", "Transaction Ref", "Amount", "Category", "Status", "Resolution", "Date"].map((h) => (
                <th key={h} style={S.th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {disputes.length === 0 ? (
              <tr><td colSpan={7} style={{ ...S.td, textAlign: "center", color: "#bbb", padding: 32 }}>No disputes found</td></tr>
            ) : disputes.map((d, i) => (
              <tr key={d.id || i} style={S.tr}>
                <td style={S.td}><span style={S.mono}>{d.id}</span></td>
                <td style={S.td}><span style={S.mono}>{d.transaction?.reference || "—"}</span></td>
                <td style={{ ...S.td, fontWeight: 700, color: BG }}>{fmtMoney(d.transaction?.amount)}</td>
                <td style={S.td}>{d.category || "—"}</td>
                <td style={S.td}>
                  <span style={{ background: (STATUS_COLOR[d.status] || "#888") + "18", color: STATUS_COLOR[d.status] || "#888", borderRadius: 20, padding: "2px 10px", fontSize: 11, fontWeight: 600 }}>
                    {d.status?.replace(/_/g, " ") || "—"}
                  </span>
                </td>
                <td style={S.td}>{d.resolution || "—"}</td>
                <td style={{ ...S.td, color: "#888" }}>{fmtDate(d.createdAt)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={S.pagination}>
        <button style={S.pgBtn} disabled={page <= 1} onClick={() => { const p = page - 1; setPage(p); load(p); }}>‹ Previous</button>
        <span style={{ color: "#888", fontSize: 13 }}>Page {page}</span>
        <button style={S.pgBtn} onClick={() => { const p = page + 1; setPage(p); load(p); }}>Next ›</button>
      </div>
    </div>
  );
}

const S = {
  root: { paddingBottom: 40 },
  pageHeader: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 24, flexWrap: "wrap", gap: 12 },
  heading: { fontSize: 22, fontWeight: 800, color: BG, margin: 0 },
  headingSub: { fontSize: 13, color: "#888", marginTop: 4 },
  alertPill: { background: "rgba(230,57,70,0.08)", border: "1px solid #e63946", borderRadius: 10, padding: "10px 16px", fontSize: 13, fontWeight: 600, color: "#e63946", display: "flex", alignItems: "center" },
  filterBar: { background: "#fff", borderRadius: 10, padding: "16px 20px", boxShadow: "0 2px 10px rgba(0,0,0,0.06)", display: "flex", flexWrap: "wrap", gap: 16, marginBottom: 20, alignItems: "flex-end" },
  filterGroup: { display: "flex", flexDirection: "column", gap: 4 },
  filterLabel: { fontSize: 11, fontWeight: 600, color: "#888", textTransform: "uppercase", letterSpacing: 0.5 },
  input: { border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "8px 12px", fontSize: 13, color: "#333", outline: "none", background: "#fafafa" },
  select: { border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "8px 12px", fontSize: 13, color: "#333", outline: "none", background: "#fafafa" },
  btn: { background: BG, border: "none", borderRadius: 8, color: "#fff", fontWeight: 600, padding: "8px 20px", cursor: "pointer", fontSize: 13 },
  btnSecondary: { background: "#f5f5f5", border: "1.5px solid #e0e0e0", borderRadius: 8, color: "#666", fontWeight: 500, padding: "8px 16px", cursor: "pointer", fontSize: 13 },
  tableWrap: { background: "#fff", borderRadius: 10, overflowX: "auto", boxShadow: "0 2px 10px rgba(0,0,0,0.06)", WebkitOverflowScrolling: "touch" },
  table: { width: "100%", borderCollapse: "collapse" },
  th: { background: BG, color: "#fff", padding: "11px 14px", textAlign: "left", fontSize: 12, fontWeight: 600 },
  tr: { borderBottom: "1px solid #f5f5f5" },
  td: { padding: "11px 14px", fontSize: 13, color: "#555", verticalAlign: "middle" },
  mono: { fontFamily: "monospace", fontSize: 12, color: "#888" },
  pagination: { display: "flex", alignItems: "center", gap: 16, marginTop: 16, justifyContent: "flex-end" },
  pgBtn: { background: "#fff", border: "1.5px solid #e0e0e0", borderRadius: 8, color: "#555", padding: "7px 18px", cursor: "pointer", fontSize: 13, fontWeight: 500 },
};
